export const calculateTotalExpenses = (expenses) => {
  return expenses.reduce((sum, expense) => {
    let montantAvecTva = 0;
    if (expense.donnees_specifiques) {
      try {
        const spec = typeof expense.donnees_specifiques === 'string'
          ? JSON.parse(expense.donnees_specifiques)
          : expense.donnees_specifiques;
        montantAvecTva = parseFloat(spec.montantAvecTva) || 0;
      } catch {
        montantAvecTva = 0;
      }
    }
    // Fallback sur montant brut si pas de montantAvecTva
    if (!montantAvecTva && expense.montant) {
      montantAvecTva = parseFloat(expense.montant) || 0;
    }
    return sum + montantAvecTva;
  }, 0);
};

export const calculateTotalAmount = (amount, tva) => {
  return parseFloat(amount) || 0;
};

export const calculateAmountBeforeTax = (amount, tva) => {
  const tvaPercentage = parseFloat(tva) || 0;
  const amountValue = parseFloat(amount) || 0;

  if (tvaPercentage <= 0) {
    return amountValue;
  }

  return amountValue / (1 + tvaPercentage / 100);
};

export const calculateKilometricAmount = async (distance, expenseId = null) => {
  const distanceValue = parseFloat(distance) || 0;
  if (distanceValue <= 0) return {
    montant: 0,
    distance_annuelle_actuelle: 0,
    nouvelle_distance_annuelle: 0,
    detail: { tranche_actuelle: 1 },
    cv: 0,
    error: null
  };

  try {
    const requestBody = { distance_trajet: distanceValue };
    
    // Ajouter l'ID de la dépense si on est en mode modification
    if (expenseId) {
      requestBody.expense_id = expenseId;
    }

    const response = await fetch('/api/employee/calculate-kilometric', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erreur inconnue' }));
      console.error('Erreur API kilométrique:', response.status, errorData);
      
      if (response.status === 401) {
        throw new Error('Session expirée. Veuillez vous reconnecter.');
      }
      
      throw new Error(errorData.error || 'Erreur lors du calcul kilométrique');
    }

    const data = await response.json();
    return {
      montant: data.montant || 0,
      distance_annuelle_actuelle: data.distance_annuelle_actuelle || 0,
      nouvelle_distance_annuelle: data.nouvelle_distance_annuelle || 0,
      detail: data.detail_calcul || { tranche_actuelle: 1 },
      cv: data.cv || 0,
      error: null
    };
  } catch (error) {
    console.error('Erreur lors du calcul kilométrique:', error);
    
    // Fallback sur l'ancien calcul simple avec informations d'erreur
    return {
      montant: distanceValue * 0.631,
      distance_annuelle_actuelle: 0,
      nouvelle_distance_annuelle: distanceValue,
      detail: { tranche_actuelle: 1 },
      cv: 0,
      error: error.message
    };
  }
};

// Version synchrone pour compatibilité (utilise l'ancien calcul simple)
export const calculateKilometricAmountSync = (distance, rate) => {
  const distanceValue = parseFloat(distance) || 0;
  const rateValue = parseFloat(rate) || 0;
  return distanceValue * rateValue;
}; 
